import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { PropertyValue } from '../../properties/properties.types';
import { backerKeys } from '../../query-key-factory';

type ConsumerPropertiesCausesResponse = {
  causes: { uuid: string }[];
};

type CausePropertiesResponse = {
  values: PropertyValue[];
};

const useGetConsumerPropertiesCauses = () => {
  const BackerApi = useBackerApi();

  const getConsumerPropertiesCauses = async () => {
    const { data } = await BackerApi.get<ConsumerPropertiesCausesResponse>(
      `consumer/properties/causes`
    );
    return data;
  };

  return useQuery({
    queryFn: getConsumerPropertiesCauses,
    queryKey: backerKeys.consumer.properties.all,
  });
};

const useGetConsumerPropertiesByCause = ({ causeId }: { causeId: string }) => {
  const BackerApi = useBackerApi();

  const getConsumerPropertiesByCause = async () => {
    const { data } = await BackerApi.get<CausePropertiesResponse>(
      `consumer/properties/causes/${causeId}`
    );
    return data.values;
  };

  return useQuery({
    queryFn: getConsumerPropertiesByCause,
    queryKey: backerKeys.consumer.properties.id(causeId).all,
  });
};

export { useGetConsumerPropertiesByCause, useGetConsumerPropertiesCauses };
